import { data } from "react-phone-code";
import { ACCOUNT_APP_LICENSES, ACCOUNT_APP_LICENSE_MESSAGE, ACCOUNT_APP_LICENSE_PURCHASES, ADD_ACCOUNT_APP_LICENSE, ADD_ACCOUNT_APP_LICENSE_PURCHASE, DELETE_ACCOUNT_APP_LICENSE, 
  DELETE_ACCOUNT_APP_LICENSE_PURCHASE, GET_ACCOUNT_APP_LICENSES, GET_ACCOUNT_APP_LICENSE_PURCHASES, HIDE_LOADING, SET_ADD_EDIT, SHOW_LOADING, UPDATE_ACCOUNT_APP_LICENSE,
   UPDATE_ACCOUNT_APP_LICENSE_PURCHASE,SAVE_ACCOUNT_APP_LICENSE_DATA,ACCOUNT_APP_LICENSES_DATA,GET_ACCOUNT_APP_LICENSE_DATA,SAVED_ACCOUNT_APP_LICENSES_DATA } from "redux/constants/accountAppLicense";


export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};

export const hideLoading = () => {
  return {
    type: HIDE_LOADING,
  };
};

export const setAddEdit = (value) => {
  return {
    type: SET_ADD_EDIT,
    addEditValue: value,
  };
};

export const getAccountAppLicenses = (requestData) => {
  return {
    type: GET_ACCOUNT_APP_LICENSES,
    payload: requestData,
  };
};

export const accountAppLicenses = (data) => {
    return {
      type: ACCOUNT_APP_LICENSES,
      accountAppLicenses: data,
    };
  };

export const saveAccountAppLicense = (data) => {
  return {
    type: ADD_ACCOUNT_APP_LICENSE,
    payload: data,
  };
};

export const saveAccountAppLicenseData = (data) => {
  return {
    type: SAVE_ACCOUNT_APP_LICENSE_DATA,
    payload: data,
  };
};

export const getLicensePricingListData = (data) => {
  return {
    type: GET_ACCOUNT_APP_LICENSE_DATA,
    payload: data,
  };
};
export const accountAppLicensesData = (data) => {
  return {
    type: ACCOUNT_APP_LICENSES_DATA,
    accountAppLicensesData: data,
  };
};

export const savedaccountAppLicensesData = (data) => {
  return {
    type: SAVED_ACCOUNT_APP_LICENSES_DATA,
    accountAppLicensesData: data,
  };
};

export const updateAccountAppLicense = (data) => {
    return {
      type: UPDATE_ACCOUNT_APP_LICENSE,
      payload: data,
    };
  };

export const deleteAccountAppLicense = (accountAppLicense) => {
  return {
    type: DELETE_ACCOUNT_APP_LICENSE,
    payload: accountAppLicense,
  };
};

export const getAccountAppLicensesPurchases = (requestData) => {
  return {
    type: GET_ACCOUNT_APP_LICENSE_PURCHASES,
    payload: requestData,
  };
};

export const accountAppLicensePurchases = (data) => {
    return {
      type: ACCOUNT_APP_LICENSE_PURCHASES,
      accountAppLicensesPurchases: data,
    };
  };

export const saveAccountAppLicensePurchase = (data) => {
  return {
    type: ADD_ACCOUNT_APP_LICENSE_PURCHASE,
    payload: data,
  };
};

export const updateAccountAppLicensePurchase = (data) => {
    return {
      type: UPDATE_ACCOUNT_APP_LICENSE_PURCHASE,
      payload: data,
    };
  };

export const deleteAccountAppLicensePurchase = (accountAppLicensePurchase) => {
  return {
    type: DELETE_ACCOUNT_APP_LICENSE_PURCHASE,
    payload: accountAppLicensePurchase,
  };
};

export const showAccountAppLicenseMessage=(data)=>{
    return {
      type : ACCOUNT_APP_LICENSE_MESSAGE,
      data:data
    }
}

